'use strict';

const Transaction = require('bunsen/models/ecomm/Transaction');
const Party = require('bunsen/models/Party');
const FinancialAmount = require('bunsen/models/FinancialAmount');
const extendCompose = require('bunsen/libraries/extendCompose');
const PrivateTransaction = extendCompose.call(Transaction, {});

/**
 * this is an extension of the transaction model intended to facilitate
 * the creation of buyer or seller initiated negotiation 2.0 transactions
 */
PrivateTransaction.extendSelf({

    defaults__: {
        offers: [
            {
                quantity: '1',
                forCompleteLot: true,
                amountPerItem: {}
            }
        ]
    },

    initialize__() {
        this._offer = this.get('offers[0]');
    },

    prepareToSaveBuyer() {
        const seller = this.get('seller');
        if (seller) {
            this._offer.set('counterParty', new Party({
                role: Party.ROLE_SELLER,
                id: seller.id
            }));
        }
        const buyer = this.get('buyer');
        if (buyer) {
            this._offer.set('initiatingParty', new Party({
                role: Party.ROLE_BUYER,
                id: buyer.id
            }));
            // use buyer preference currency for buyer initiated transactions
            this._offer.set('amountPerItem.currency',
                buyer.get('profile.currency') || FinancialAmount.CURRENCY_USD);
        }
        const item = this.get('item');
        if (item) {
            this.set('currencyConversionRateEvent',
                item.get('pricing.totalAmount.conversionRateEvent'));
        }
    },

    prepareToSaveSeller() {
        const seller = this.get('seller');
        if (seller) {
            this._offer.set('initiatingParty', new Party({
                role: Party.ROLE_SELLER,
                id: seller.id
            }));
        }
        const buyer = this.get('buyer');
        if (buyer) {
            this._offer.set('counterParty', new Party({
                role: Party.ROLE_BUYER,
                id: buyer.id
            }));
        }
        const item = this.get('item');
        if (item) {
            const amount = item.get('pricing.totalAmount');
            this.set('currencyConversionRateEvent', amount.get('conversionRateEvent'));
            this._offer.set('amountPerItem.currency', amount.get('currency'));
        }
    }
});

module.exports = PrivateTransaction;



// WEBPACK FOOTER //
// ./~/bunsen/models/ecomm/PrivateTransaction.es.js